import { styled } from "@mui/material";
const ValidationSummaryIconContainer = styled("div", {
  name: "ValidationSummaryIconContainer",
  slot: "Root",
  skipSx: true
})(({ theme }) => ({
  marginRight: theme.spacing(1),
  display: "flex",
  flexShrink: "0"
}));
export {
  ValidationSummaryIconContainer
};
//# sourceMappingURL=ValidationSummaryIconContainer.js.map
